import { trackProductEvent, type AnalyticsProperties } from '@/lib/analytics';

export const trackAIMealPlanSetupViewed = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Setup Viewed', properties);
};

export const trackAIMealPlanClientSelected = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Client Selected', properties);
};

export const trackAIMealPlanClientGoalsEditClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Client Goals Edit Clicked', properties);
};

export const trackAIMealPlanDietaryPreferencesEditClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Dietary Preferences Edit Clicked', properties);
};

export const trackAIMealPlanClientGoalsSaved = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Client Goals Saved', properties);
};

export const trackAIMealPlanDietaryPreferencesSaved = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Dietary Preferences Saved', properties);
};

export const trackAIMealPlanUseClientMealSlotsEnabled = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Use Client Meal Slots Enabled', properties);
};

export const trackAIMealPlanUseClientMealSlotsDisabled = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Use Client Meal Slots Disabled', properties);
};

export const trackAIMealPlanSlotAdded = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Slot Added', properties);
};

export const trackAIMealPlanSlotRemoved = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Slot Removed', properties);
};

export const trackAIMealPlanModelSelected = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Model Selected', properties);
};

export type AIMealPlanExitClickEvent = 'AI Meal Plan Back Clicked' | 'AI Meal Plan Cancel Clicked';

export const trackAIMealPlanExitClicked = (
  eventName: AIMealPlanExitClickEvent,
  properties: AnalyticsProperties
) => {
  trackProductEvent(eventName, properties);
};

export const trackAIMealPlanSetupCompleted = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Setup Completed', properties);
};

export const trackAIMealPlanGenerateClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Generate Clicked', properties);
};

export const trackAIMealPlanSingleSlotWarningCancelClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Single Slot Warning Cancel Clicked', properties);
};

export const trackAIMealPlanSingleSlotWarningContinueClicked = (properties: AnalyticsProperties) => {
  trackProductEvent('AI Meal Plan Single Slot Warning Continue Clicked', properties);
};
